module.exports = __webpack_public_path__ + "static/media/4.8eb37ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/4.png
// module id = 408
// module chunks = 0